/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Options_Cli_Select_LocationInputs */

const en_options_cli_select_location = /** @type {(inputs: Options_Cli_Select_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select ${i?.tool} location`)
};

const fr_options_cli_select_location = /** @type {(inputs: Options_Cli_Select_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sélectionner l'emplacement de ${i?.tool}`)
};

const de_options_cli_select_location = /** @type {(inputs: Options_Cli_Select_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Standort ${i?.tool} auswählen`)
};

const it_options_cli_select_location = /** @type {(inputs: Options_Cli_Select_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleziona la posizione ${i?.tool}`)
};

const ru_options_cli_select_location = /** @type {(inputs: Options_Cli_Select_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Выберите местоположение ${i?.tool}`)
};

const es_options_cli_select_location = /** @type {(inputs: Options_Cli_Select_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleccione la ubicación ${i?.tool}`)
};

const zh_cn2_options_cli_select_location = /** @type {(inputs: Options_Cli_Select_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`选择 ${i?.tool} 位置`)
};

const ja_options_cli_select_location = /** @type {(inputs: Options_Cli_Select_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tool} の場所を選択`)
};

const hi_options_cli_select_location = /** @type {(inputs: Options_Cli_Select_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tool} स्थान का चयन करें`)
};

const pt_pt2_options_cli_select_location = /** @type {(inputs: Options_Cli_Select_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecione a localização ${i?.tool}`)
};

/**
* | output |
* | --- |
* | "Select {tool} location" |
*
* @param {Options_Cli_Select_LocationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_select_location = /** @type {((inputs: Options_Cli_Select_LocationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Select_LocationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_select_location(inputs)
	if (locale === "de") return de_options_cli_select_location(inputs)
	if (locale === "it") return it_options_cli_select_location(inputs)
	if (locale === "ru") return ru_options_cli_select_location(inputs)
	if (locale === "es") return es_options_cli_select_location(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_select_location(inputs)
	if (locale === "ja") return ja_options_cli_select_location(inputs)
	if (locale === "hi") return hi_options_cli_select_location(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_select_location(inputs)
	return en_options_cli_select_location(inputs)
});